import { graphql } from "gql";

const GET_USER_ORGANIZATIONS_GROUPS = graphql(`
  query GetUserGroupsAtDashboard($after: String, $first: Int!) {
    me {
      __typename
      userEmail
      groups(after: $after, first: $first) {
        edges {
          node {
            name
            organization
            permissions
            serviceAttributes
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`);

export { GET_USER_ORGANIZATIONS_GROUPS };
